export const generateRecaptcha = (action) => {
  return true;
}